<template>
  <div class="container">
    <h2>Service usage</h2>
    <b-row>
      <b-col cols="12" md="8">
      </b-col>
      <b-col cols="12" md="4" class="text-right">
        <b-form-select v-model="timeperiod" :options="timeperiods" size="sm" class="mt-3" @change="updatedata()"></b-form-select>
      </b-col>
    </b-row>
    <div v-if="transcribeLoaded" class="mt-4">
      <h4>Speech to text <a :href="csvTranscribeLink" target="_blank" style="font-size: 0.7em; font-weight:normal">(csv)</a></h4>
      <bar-chart
        :chartdata="transcribeData"
        :options="options('Seconds transcribed')"/>
    </div>
    <div v-if="translateLoaded" class="mt-4">
      <h4>Machine translation <a :href="csvTranslateLink" target="_blank" style="font-size: 0.7em; font-weight:normal">(csv)</a></h4>
      <bar-chart
        :chartdata="translateData"
        :options="options('Characters translated')"/>
    </div>
  </div>

</template>

<script>
// import LineChart from '@/components/BarChart.vue'
import apiClient from '@/services/api_client_crm.js'
import Vue from 'vue'

Vue.component('bar-chart', function (resolve) {
  // This special require syntax will instruct Webpack to
  // automatically split your built code into bundles which
  // are loaded over Ajax requests.
  require(['@/components/BarChart.vue'], resolve)
})

export default {
  // name: 'LineChartContainer',
  name: 'UsageCharts',
  components: {
    // 'line-chart': LineChart
  },
  computed: {
    tz () {
      return Intl.DateTimeFormat().resolvedOptions().timeZone
    },
    csvTranslateLink () {
      return process.env.VUE_APP_CRM_API_BASE_URL + '/api/usage/csv/translate?period=' + this.timeperiod + '&tz=' + encodeURIComponent(this.tz)
    },
    csvTranscribeLink () {
      return process.env.VUE_APP_CRM_API_BASE_URL + '/api/usage/csv/transcribe?period=' + this.timeperiod + '&tz=' + encodeURIComponent(this.tz)
    },
    viewedTask () {
      return (this.tasks) ? this.tasks.find(x => x.id === this.viewId) : null
    },
    tabulatedTasks () {
      const start = this.perPage * (this.currentPage - 1)
      const end = this.perPage * this.currentPage
      return (this.tasks) ? this.tasks.slice(start, end) : []
    }
  },
  data: () => ({
    timeperiod: '7d', // default to 7 days
    timeperiods: [
      { value: 0, text: 'Please select an option' },
      { value: 'td', text: 'Today' },
      { value: '12h', text: 'Last 12 hours' },
      { value: '24h', text: 'Last 24 hours' },
      { value: 'yd', text: 'Yesterday' },
      { value: 'tw', text: 'This week' },
      { value: '7d', text: 'Last 7 days' },
      { value: 'tm', text: 'This month' },
      { value: '30d', text: 'Last 30 days' },
      { value: 'lm', text: 'Last month' },
      { value: '90d', text: 'Last 90 days' },
      { value: 'ty', text: 'This year' }
    ],
    transcribeLoaded: false,
    transcribeData: null,
    translateLoaded: false,
    translateData: null
    // options: {
    //   // title: {
    //   //   display: true,
    //   //   text: 'Daffy duck'
    //   // },
    //   responsive: true,
    //   maintainAspectRatio: false,
    //   scales: {
    //     yAxes: [
    //       {
    //         scaleLabel: {
    //           display: true,
    //           labelString: 'Seconds transcribed'
    //         },
    //         ticks: {
    //           min: 0,
    //           callback: function (value) {
    //             return value.toLocaleString()
    //           }
    //         }
    //       }
    //     ]
    //   }
    // }
  }),
  methods: {
    options (label) {
      return {
        responsive: true,
        maintainAspectRatio: false,
        // title: {
        //   display: true,
        //   text: 'Daffy duck'
        // },
        legend: {
          display: false
        },
        scales: {
          yAxes: [
            {
              scaleLabel: {
                display: true,
                labelString: label
              },
              ticks: {
                min: 0,
                suggestedMax: 100,
                callback: function (value) {
                  return value.toLocaleString()
                }
              }
            }
          ]
        }
      }
    },
    loadtranscribe () {
      this.transcribeLoaded = false
      const tz = Intl.DateTimeFormat().resolvedOptions().timeZone
      try {
        apiClient
          .get(`/api/usage/transcribe?period=${this.timeperiod}&tz=${encodeURIComponent(tz)}`)
          .then(response => {
            // console.log(response.data)
            this.transcribeData = response.data
            this.transcribeLoaded = true
          })
          .catch(err => {
            // console.log(`Unable to retrieve or set data: ${err}`)
            console.log(err)
            return Promise.reject(err)
          })
      } catch (e) {
        console.error(e)
      }
    },
    loadtranslate () {
      this.translateLoaded = false
      const tz = Intl.DateTimeFormat().resolvedOptions().timeZone
      try {
        apiClient
          .get(`/api/usage/translate?period=${this.timeperiod}&tz=${encodeURIComponent(tz)}`)
          .then(response => {
            // console.log(response.data)
            this.translateData = response.data
            this.translateLoaded = true
          })
          .catch(err => {
            // console.log(`Unable to retrieve or set data: ${err}`)
            console.log(err)
            return Promise.reject(err)
          })
      } catch (e) {
        console.error(e)
      }
    },
    updatedata () {
      this.loadtranslate()
      this.loadtranscribe()
    }
  },
  created () {
    this.loadtranslate()
    this.loadtranscribe()
  }
}

</script>
